import { getImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'

import { BackgroundImage } from '@application/Interfaces/Atoms/BackgroundImage/BackgroundImage'
import { Html } from '@application/Interfaces/Atoms/Html'
import { Revealer } from '@application/Interfaces/Atoms/Revealer'
import { Tilt } from '@application/Interfaces/Atoms/Tilt'
import { ArrowDirectionIcon } from '@application/Interfaces/Icons'
import { Button } from '@application/Interfaces/Molecules/Button'
import type { ImageHoverDescriptionLargeType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import Container from '@mui/material/Container'

import {
    Content,
    ItemDescription,
    Link,
    ServicesItem,
    ServicesItemWrapper,
    Title,
    Wrapper,
} from './ImageHoverDescriptionLarge.styled'

export const ImageHoverDescriptionLarge = (props: ImageHoverDescriptionLargeType): JSX.Element => {
    const { link, linkLabel, contactUsList } = props

    return (
        <Wrapper>
            <Container>
                <Revealer
                    multi={{
                        delay: 150,
                    }}
                >
                    <Grid container>
                        {contactUsList.map((item, i) => {
                            const image = getImage(item.image.localFile) as IGatsbyImageData
                            const columnSize = contactUsList.length % 2 && i === contactUsList.length - 1 ? 12 : 6
                            const Wrapper = item.imageAnimation ? Tilt : React.Fragment
                            return (
                                <Grid
                                    item
                                    xs={12}
                                    md={columnSize}
                                    key={item.id}
                                    mdUpSpacingRight={3}
                                    mdUpSpacingLeft={3}
                                    mdUpSpacingBottom={6}
                                    mdDownSpacingBottom={6}
                                >
                                    <Wrapper>
                                        <ServicesItemWrapper>
                                            <BackgroundImage image={image} title={item.image?.alternativeText}>
                                                <ServicesItem>
                                                    <ItemDescription>
                                                        <Title>{item.title}</Title>
                                                        <Content>
                                                            <Html
                                                                content={item.description.data.childMarkdownRemark.html}
                                                            />
                                                            {item.link && (
                                                                <Link to={item.link}>
                                                                    {item.linkLabel}
                                                                    <ArrowDirectionIcon />
                                                                </Link>
                                                            )}
                                                        </Content>
                                                    </ItemDescription>
                                                </ServicesItem>
                                            </BackgroundImage>
                                        </ServicesItemWrapper>
                                    </Wrapper>
                                </Grid>
                            )
                        })}
                    </Grid>
                    {link && linkLabel && (
                        <Grid container justifyContent="center">
                            <Link to={link}>
                                <Button size="small">{linkLabel}</Button>
                            </Link>
                        </Grid>
                    )}
                </Revealer>
            </Container>
        </Wrapper>
    )
}
